"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const dayjs_1 = __importDefault(require("dayjs"));
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const utils_1 = require("src/utils/utils");
const Chevron_1 = __importDefault(require("src/components/svg/Chevron"));
const Datetime_1 = __importDefault(require("src/components/svg/Datetime"));
const CustomToggle = react_1.default.forwardRef(({ date, onClick, date_range_off = false }, ref) => {
    const click = (e) => {
        e.preventDefault();
        if (date_range_off) {
            return;
        }
        onClick(e);
    };
    return ((0, jsx_runtime_1.jsxs)(react_bootstrap_1.Button, Object.assign({ variant: "", className: "btn-outline", onClick: click }, { children: [!date_range_off && (0, jsx_runtime_1.jsx)(Datetime_1.default, {}), (0, utils_1.periodFormat)(date.from, date.to)] })));
});
CustomToggle.displayName = "CustomToggle";
const CustomMenu = react_1.default.forwardRef(({ children, handleCustomChange, rootCloseEvent, open, onClose }, ref) => {
    const handleRootClose = (event) => {
        onClose(event, { source: "rootClose" });
    };
    // TODO: Пока не работает и не по стилю. Реализовать при необходимости
    return ((0, jsx_runtime_1.jsx)(react_bootstrap_1.Overlay, Object.assign({ target: ref, show: !open, onHide: handleRootClose, rootCloseEvent: rootCloseEvent }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: ref, className: "dropdown-menu filter-dropdown" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "arrow" }), (0, jsx_runtime_1.jsx)("form", { children: children }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "form-actions" }, { children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Dropdown.Item, { children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, Object.assign({ variant: "info", className: "btn-block", onClick: (e) => {
                                handleCustomChange();
                                handleRootClose(e);
                            } }, { children: i18n_1.default.t("Apply") })) }) }))] })) })));
});
CustomMenu.displayName = "CustomMenu";
const FilterDataRange = ({ from, to, defaultPeriod = "today", future = true, today = true, yesterday = true, week = true, month = true, quarter = true, part_year = false, year = false, date_range_off = false, reverse = false, has_period_restriction = false, period_restriction = 90, onChange, }) => {
    const [date, setDate] = (0, react_1.useState)({
        period: defaultPeriod,
        from: from ? (0, dayjs_1.default)(from) : (0, dayjs_1.default)(),
        to: to ? (0, dayjs_1.default)(to) : (0, dayjs_1.default)(),
        init: from && to ? false : true,
    });
    const [datepicker, setDatePicker] = (0, react_1.useState)({
        from: date.from,
        to: date.to,
    });
    const setDates = (period, from, to) => {
        setDate({
            period: period,
            from: from,
            to: to,
            init: false,
        });
        setDatePicker({
            from: from,
            to: to,
        });
    };
    const switchPeriod = (period) => {
        if (period == "today") {
            setDates(period, (0, dayjs_1.default)(), (0, dayjs_1.default)());
        }
        else if (period == "yesterday") {
            setDates(period, (0, dayjs_1.default)().add(-1, "day"), (0, dayjs_1.default)().add(-1, "day"));
        }
        else if (period == "week") {
            let from = (0, dayjs_1.default)();
            let to = (0, dayjs_1.default)();
            if (from.weekday() != 0) {
                from = from.subtract(from.weekday(), "day");
            }
            if (future && to.weekday() != 6) {
                to = to.add(6 - to.weekday(), "day");
            }
            setDates(period, from, to);
        }
        else if (period == "month") {
            const from = (0, dayjs_1.default)().set("date", 1);
            let to = (0, dayjs_1.default)();
            if (future) {
                to = to.set("date", 1).add(1, "months").add(-1, "day");
            }
            setDates(period, from, to);
        }
        else if (period == "quarter") {
            let from = (0, dayjs_1.default)();
            let to = (0, dayjs_1.default)();
            const start_month = { 1: 1, 2: 4, 3: 7, 4: 10 }[from.quarter()];
            if (from.month() != start_month - 1) {
                from = from.add(-from.month() + start_month - 1, "month");
            }
            from = from.set("date", 1);
            if (future) {
                to = to
                    .set("date", 1)
                    .add(start_month + 2 - to.month(), "months")
                    .add(-1, "day");
            }
            setDates(period, from, to);
        }
        else if (period == "part_year") {
            const from = (0, dayjs_1.default)().set("date", 1).add(-5, "month");
            let to = (0, dayjs_1.default)();
            if (future) {
                to = to.set("date", 1).add(1, "months").add(-1, "day");
            }
            setDates(period, from, to);
        }
        else if (period == "year") {
            let to = (0, dayjs_1.default)();
            const from = (0, dayjs_1.default)().set("date", 1).add(-11, "month");
            if (future) {
                to = to.set("date", 1).add(1, "months").add(-1, "day");
            }
            setDates(period, from, to);
        }
    };
    const switchDirection = (direction) => {
        if (date.period == "month") {
            setDate({
                period: date.period,
                from: date.from.add(direction * 1, "month"),
                to: date.to.add(direction * 1, "month").endOf("month"),
                init: false,
            });
        }
        else if (date.period == "week") {
            setDate({
                period: date.period,
                from: date.from.add(direction * 1, "week"),
                to: date.to.add(direction * 1, "week"),
                init: false,
            });
        }
        else if (date.period == "quarter") {
            setDate({
                period: date.period,
                from: date.from.add(direction * 1, "quarter"),
                to: date.to.add(direction * 1, "quarter").endOf("month"),
                init: false,
            });
        }
        else if (date.period == "part_year") {
            setDate({
                period: date.period,
                from: date.from.add(direction * 6, "month"),
                to: date.to.add(direction * 6, "month").endOf("month"),
                init: false,
            });
        }
        else if (date.period == "year") {
            setDate({
                period: date.period,
                from: date.from.add(direction * 1, "year"),
                to: date.to.add(direction * 1, "year").endOf("month"),
                init: false,
            });
        }
        else if (date.period == "custom") {
            const diff = date.to.diff(date.from, "days");
            let directionOffset = direction;
            if (date.from.day() != date.to.day()) {
                directionOffset *= 2;
            }
            setDate({
                period: date.period,
                from: date.from.add(direction * diff + directionOffset, "day"),
                to: date.to.add(direction * diff + directionOffset, "day"),
                init: false,
            });
        }
    };
    const handleDatePickerChange = (value, param) => {
        setDatePicker(Object.assign(Object.assign({}, datepicker), { [param]: (0, dayjs_1.default)(value) }));
    };
    const handleCustomChange = () => {
        setDate({
            period: "custom",
            from: datepicker.from,
            to: datepicker.to,
            init: false,
        });
    };
    (0, react_1.useEffect)(() => {
        if (!date.init) {
            onChange(date.period, date.from, date.to);
        }
    }, [date]);
    (0, react_1.useEffect)(() => {
        if (date.init) {
            switchPeriod(date.period);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (has_period_restriction &&
            period_restriction > 0 &&
            datepicker.to.diff(datepicker.from, "days") > period_restriction) {
            setDatePicker(Object.assign(Object.assign({}, datepicker), { to: datepicker.from.add(period_restriction, "days") }));
        }
    }, [handleDatePickerChange]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "d-flex mb-4", style: { gap: "12px" } }, { children: [(0, jsx_runtime_1.jsxs)(react_bootstrap_1.ToggleButtonGroup, Object.assign({ value: date.period, type: "radio", name: "period", className: "pull-left", onChange: (e) => {
                    switchPeriod(e);
                } }, { children: [today && ((0, jsx_runtime_1.jsx)(react_bootstrap_1.ToggleButton, Object.assign({ id: "period-today", variant: date.period == "today" ? "primary" : "", className: "btn-outline", value: "today" }, { children: i18n_1.default.t("now") }))), yesterday && ((0, jsx_runtime_1.jsx)(react_bootstrap_1.ToggleButton, Object.assign({ id: "period-yesterday", variant: date.period == "yesterday" ? "primary" : "", className: "btn-outline", value: "yesterday" }, { children: i18n_1.default.t("Yesterday") }))), week && ((0, jsx_runtime_1.jsx)(react_bootstrap_1.ToggleButton, Object.assign({ id: "period-week", variant: date.period == "week" ? "primary" : "", className: "btn-outline", value: "week" }, { children: i18n_1.default.t("A week") }))), month && ((0, jsx_runtime_1.jsx)(react_bootstrap_1.ToggleButton, Object.assign({ id: "period-month", variant: date.period == "month" ? "primary" : "", className: "btn-outline", value: "month" }, { children: i18n_1.default.t("Month") }))), quarter && ((0, jsx_runtime_1.jsx)(react_bootstrap_1.ToggleButton, Object.assign({ id: "period-quarter", variant: date.period == "quarter" ? "primary" : "", className: "btn-outline", value: "quarter" }, { children: i18n_1.default.t("Quarter") }))), part_year && ((0, jsx_runtime_1.jsx)(react_bootstrap_1.ToggleButton, Object.assign({ id: "period-part_year", variant: date.period == "part_year" ? "primary" : "", className: "btn-outline", value: "part_year" }, { children: i18n_1.default.t("Half a year") }))), year && ((0, jsx_runtime_1.jsx)(react_bootstrap_1.ToggleButton, Object.assign({ id: "period-year", variant: date.period == "year" ? "primary" : "", className: "btn-outline", value: "year" }, { children: i18n_1.default.t("Year") })))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `d-flex ${reverse ? "reverse-blocks" : ""}`, style: { gap: "12px" } }, { children: [!(date.period == "today" || date.period == "yesterday") && ((0, jsx_runtime_1.jsxs)(react_bootstrap_1.ButtonGroup, { children: [(0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, Object.assign({ variant: "", className: "btn-outline btn_onlyicon", onClick: () => switchDirection(-1) }, { children: (0, jsx_runtime_1.jsx)(Chevron_1.default, {}) })), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, Object.assign({ variant: "", className: "btn-outline btn_onlyicon", onClick: () => switchDirection(1) }, { children: (0, jsx_runtime_1.jsx)(Chevron_1.default, { style: { rotate: "180deg" } }) }))] })), (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Dropdown, Object.assign({ id: "filter-data-range" }, { children: [(0, jsx_runtime_1.jsx)(CustomToggle, { date: date, date_range_off: date_range_off }), (0, jsx_runtime_1.jsx)(CustomMenu, Object.assign({ className: "filter-dropdown", handleCustomChange: handleCustomChange }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "form-group" }, { children: [(0, jsx_runtime_1.jsx)("label", { children: i18n_1.default.t("Period") }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "form-inline input-group" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-sm-6" }, { children: (0, jsx_runtime_1.jsx)(react_datepicker_1.default, { dateFormat: "yyyy-MM-dd", className: "form-control", onChange: (value) => handleDatePickerChange(value, "from"), placeholderText: i18n_1.default.t("From"), selected: datepicker.from.toDate() }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-sm-6" }, { children: (0, jsx_runtime_1.jsx)(react_datepicker_1.default, { dateFormat: "yyyy-MM-dd", className: "form-control", onChange: (value) => handleDatePickerChange(value, "to"), placeholderText: i18n_1.default.t("Until"), selected: datepicker.to.toDate(), maxDate: period_restriction > 0 ? (0, dayjs_1.default)(datepicker.from).add(period_restriction, "days").toDate() : null }) }))] }))] })) }))] }))] }))] })));
};
exports.default = FilterDataRange;
